import { useEffect } from 'react';
import { useContentWatch } from '../../../../../hooks/form';
import { TinyMCE } from '../types';
import { useContentFromEditor } from './useContentFromEditor';

export const useGetNewContentEffect = (editor: TinyMCE | null) => {
  const contentFromContext = useContentWatch() ?? '';
  const contentFromEditor = useContentFromEditor(editor);

  const isEditorAvailable = editor && editor.initialized;
  const isEditorContentOutOfDate = contentFromContext !== contentFromEditor;

  useEffect(() => {
    if (isEditorAvailable && isEditorContentOutOfDate) {
      editor.setContent(contentFromContext);
    }
  }, [isEditorAvailable, isEditorContentOutOfDate]);
};
